import { render, staticRenderFns } from "./CreateMessageListModal.vue?vue&type=template&id=4578ec88&scoped=true&"
import script from "./CreateMessageListModal.vue?vue&type=script&lang=js&"
export * from "./CreateMessageListModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateMessageListModal.vue?vue&type=style&index=0&id=4578ec88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4578ec88",
  null
  
)

export default component.exports